export default __webpack_public_path__ + "static/media/oval.319d0aec.svg";